<template>
  <div>
    <v-row :id="title.replace(/\s/g, '').toLowerCase() + '-title'">
      <v-col>
        <h2>
          <collapsible-icon-button v-if="collapsible" :collapsed="value" @click="clickCollapseButton" />
          {{ title }}

          <template v-if="addButtonVisible && !isReadOnly">
            <v-btn v-if="!menuItems" class="ml-3" fab small @click="clickPlusButton">
              <v-icon>{{ buttonIcon }}</v-icon>
            </v-btn>
            <menu-button
              v-else
              :items="menuItems"
              @click-item="clickItem"
              :button-attrs="{ fab: true, small: true, class: 'ml-3' }"
            >
              <template v-slot:buttonContent>
                <v-icon>mdi-plus</v-icon>
              </template>
            </menu-button>
          </template>
        </h2>
      </v-col>
    </v-row>
    <div class="pl-10">
      <v-subheader v-if="subtitle" class="text--secondary pl-0">
        {{ subtitle }}
      </v-subheader>

      <v-expand-transition>
        <div v-show="value">
          <slot />
        </div>
      </v-expand-transition>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import MenuButton from '@/components/menu/MenuButton.vue';
import { MenuItemInterface } from '@/domain/interface/intern/MenuItemInterface';
import CollapsibleIconButton from '@/components/button/CollapsibleIconButton.vue';
import BaseInputMixin from '@/mixins/inputMixins/base/BaseInputMixin';
import { mixins } from 'vue-class-component';

@Component({
  components: { CollapsibleIconButton, MenuButton },
})
export default class SubtitleCollapsibleWithAdd extends mixins(BaseInputMixin) {
  @Prop({ default: false }) value!: boolean;
  @Prop(String) readonly title?: string;
  @Prop(String) readonly subtitle?: string;
  @Prop({ default: false }) readonly collapsible!: boolean;
  @Prop({ default: true }) readonly addButtonVisible!: boolean;
  @Prop({ default: 'icon-plus' }) readonly buttonIcon!: string;
  @Prop(Array) readonly menuItems!: MenuItemInterface[];

  clickPlusButton() {
    this.$emit('add');
  }

  clickCollapseButton() {
    this.$emit('input', !this.value);
  }

  clickItem(item: MenuItemInterface) {
    this.$emit('click-item', item);
  }
}
</script>
